import(/* webpackMode: "eager" */ "/opt/build/repo/packages/boat/src/app/account/inbox/page.tsx");
